// @flow
import type {
  StockShipmentsRecord,
  AllocationRecord,
} from '../modules/inventory'; // TODO: Resolve this
// eslint-disable-next-line import/no-cycle
import { type Action } from '../store';

import {
  type Inventory,
  disjunctionByStock,
  mergedStock,
  disjunctionByAllocation,
  mergedAllocations,
  withoutConstrainedAllocations,
  withoutStockItemKeyAllocations,
  emptyInventory,
} from 'modules/inventory';
import * as at from 'actions/action-types/inventory';

export type InventoryState = Inventory;

export const initialState: InventoryState = emptyInventory();

export default (
  state: InventoryState = initialState,
  action: Action,
): InventoryState => {
  switch (action.type) {
    case at.UPDATE_STOCK_FOR_STOCK_ITEMS:
      return ((changeset: $ReadOnlyArray<StockShipmentsRecord>) =>
        changeset.length === 0 ? state : mergedStock(state, changeset))(
        disjunctionByStock(state, action.payload),
      );
    case at.ALLOCATE_STOCK_FOR_STOCK_ITEMS:
      return ((changeset: $ReadOnlyArray<AllocationRecord>) =>
        changeset.length === 0 ? state : mergedAllocations(state, changeset))(
        disjunctionByAllocation(state, action.payload),
      );
    case at.CLEAR_ALLOCATIONS:
      return action.payload.reduce(
        (acc, { stockItemKey, pageItemIds }) =>
          withoutStockItemKeyAllocations(stockItemKey, pageItemIds)(acc),
        state,
      );
    case at.CLEAR_CONSTRAINED_ALLOCATIONS:
      return withoutConstrainedAllocations(state);
    case at.CLEAR_INVENTORY:
      return initialState;
    default:
      return state;
  }
};
